import { Flex, Typography } from "antd";
import { OGDescriptionCard } from "./components/DescriptionCard/Card";
import { Roles } from "Constants/roleEnum";

const roles = [
  {
    title: "Working Professionals/Entrepreneurs",
    description:
      "I am a working professional or entrepreneur willing to mentor and guide prospective students based on my career and industry experience.",
    role: Roles.ONEGRAD_HERO,
  },
  {
    title: "Student Counselor",
    description:
      "I am a current student willing to help future applicants with applications, campus life, and student experiences.",
    role: Roles.ONEGRAD_SENIOR,
  },
  {
    title: "Professional Counselor",
    description:
      "I am a trained expert in college admissions and counseling, offering professional guidance to applicants.",
    role: Roles.ONEGRAD_COUNSELOR,
  },
  {
    title: "College Representative",
    description:
      "I work for a college or university and would like to engage with prospective applicants for our institution.",
    role: Roles.ONEGRAD_COLLEGE_REP,
  },
];

export const DescriptionPage = () => {
  const { Title } = Typography;

  return (
    <Flex vertical style={{ height: "100%", overflow: "auto", padding: 16 }}>
      <div
        className="navbar-logo-container mobile-menu-logo"
        style={{ alignSelf: "flex-start" }}
      >
        <img
          src="https://stagingonegrad.blob.core.windows.net/fe-assets/logo.png"
          alt="logo"
          className="navbar-main-logo"
        />
      </div>

      <Flex vertical justify="center" align="center" style={{ flex: 1 }}>
        <Title level={2}>Choose your path</Title>

        <Flex justify="center" align="stretch" wrap style={{ maxWidth: "90%" }}>
          {roles.map((role) => (
            <OGDescriptionCard
              key={role.role}
              title={role.title}
              role={role.role}
              description={role.description}
            />
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};
